import * as yup from 'yup';

function name(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'EDITFORM_NAME_FIELD_IS_REQUIRED',
        defaultMessage: 'Name is required',
      }),
    )
    .max(
      200,
      formatMessage({
        id: 'EDITFORM_NAME_FIELD_MAX_CHARS_200',
        defaultMessage: 'Name should be less than 200 chars',
      }),
    );
}

function path(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'EDITFORM_PATH_FIELD_IS_REQUIRED',
        defaultMessage: 'Path is required',
      }),
    )
    .max(
      500,
      formatMessage({
        id: 'EDITFORM_PATH_FIELD_MAX_CHARS_500',
        defaultMessage: 'Path should be less than 500 chars',
      }),
    );
}

function isActive(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'EDITFORM_ISACTIVE_FIELD_IS_REQUIRED',
      defaultMessage: 'Is Active is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      name: name(formatMessage),
      path: path(formatMessage),
      isActive: isActive(formatMessage),
    })
    .required();

export default validationSchema;
